export default {
	matching: 'Matching'
}